import { render, staticRenderFns } from "./krungsri_statement.vue?vue&type=template&id=107cb0ee&scoped=true&"
import script from "./krungsri_statement.vue?vue&type=script&lang=js&"
export * from "./krungsri_statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107cb0ee",
  null
  
)

export default component.exports